import { Portal } from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import { Button } from '@superops/ui-design-system';
import { noop } from 'lodash';
import React from 'react';
import styled from 'styled-components';

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: all 100ms cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: 200ms;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${(props) => (props.zIndex ? `${props.zIndex}` : '999')};
  & .modal-content {
    transform: translateY(100px);
    transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0;
  }

  &.active {
    transition-duration: 250ms;
    transition-delay: 0ms;
    opacity: 1;

    & .modal-content {
      transform: translateY(0);
      opacity: 1;
      transition-delay: 150ms;
      transition-duration: 350ms;
    }
  }
`;
const Content = styled.div`
  position: relative;
`;

function Modal(props) {
  const [active, setActive] = React.useState(false);
  const { open, onClose, locked, className, zIndex } = props;
  const backdrop = React.useRef(null);

  React.useEffect(() => {
    const { current } = backdrop;

    const transitionEnd = () => setActive(open);

    const keyHandler = (e) =>
      !locked && [27].indexOf(e.which) >= 0 && onClose();

    const clickHandler = (e) => !locked && e.target === current && onClose();

    if (current) {
      current.addEventListener('transitionend', transitionEnd);
      current.addEventListener('click', clickHandler);
      window.addEventListener('keyup', keyHandler);
    }

    if (open) {
      window.setTimeout(() => {
        document.activeElement.blur();
        setActive(open);
        // document.querySelector('#root').setAttribute('inert', 'true');
      }, 10);
    }

    return () => {
      if (current) {
        current.removeEventListener('transitionend', transitionEnd);
        current.removeEventListener('click', clickHandler);
      }

      // document.querySelector('#root').removeAttribute('inert');
      window.removeEventListener('keyup', keyHandler);
    };
  }, [open, locked, onClose]);

  return (
    <>
      {(open || active) && (
        <Portal className={className || 'modal-portal'}>
          <Backdrop
            ref={backdrop}
            zIndex={zIndex}
            className={active && open && 'active'}
          >
            <Content className="modal-content">{props.children}</Content>
          </Backdrop>
        </Portal>
      )}
    </>
  );
}

function CloseButton({ onClose = noop }) {
  return <Button icon={<SVGIcon name="Close" />} onClick={onClose} plain />;
}

Modal.CloseButton = CloseButton;

export default Modal;
